import './SupportView.scss';

export { default } from './SupportView';
